import { getBalance } from "@wagmi/core";
import { formatEther } from "viem";
import { getWagmiConfig } from "@/lib/wallet";
import { networks } from "@/lib/wallet-networks";

export function getExplorerUrl(chainId: number | null | undefined, txHash: string): string | null {
  if (!chainId || !txHash) return null;
  const net = networks.find((n) => n.id === chainId);
  const base = net?.blockExplorers?.default?.url;
  if (!base) return null;
  return `${base.replace(/\/$/, "")}/tx/${txHash}`;
}

export function getExplorerName(chainId: number | null | undefined): string {
  if (!chainId) return "Explorer";
  return networks.find((n) => n.id === chainId)?.blockExplorers?.default?.name ?? "Explorer";
}

/**
 * Ensure `address` has enough native balance on `chainId` to cover `needed` wei.
 * Throws a human-readable error if the balance is short.
 */
export async function assertBalance(address: `0x${string}`, chainId: number, needed: bigint): Promise<void> {
  if (needed <= 0n) return;
  const bal = await getBalance(getWagmiConfig(), { address, chainId });
  if (bal.value < needed) {
    const sym = bal.symbol || "ETH";
    throw new Error(
      `Insufficient ${sym} balance. Need ${formatEther(needed)} ${sym}, wallet has ${formatEther(bal.value)} ${sym}.`,
    );
  }
}
